import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const DesignatedSmokingIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "DesignatedSmokingIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M7.60165 15.3082H20.8674C21.6194 15.3082 22.229 15.9178 22.229 16.6698V18.2259C22.229 18.9779 21.6194 19.5875 20.8674 19.5875H7.60164C7.27936 19.5875 7.0181 19.3262 7.0181 19.004V15.8918C7.0181 15.5695 7.27937 15.3082 7.60165 15.3082ZM10.5193 16.4753V18.4204H17.1717V16.4753H10.5193ZM21.0619 18.2259V16.6698C21.0619 16.5624 20.9748 16.4753 20.8674 16.4753H18.3388V18.4204H20.8674C20.9749 18.4204 21.0619 18.3333 21.0619 18.2259ZM8.18519 18.4204H9.35227V16.4753H8.18519V18.4204Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M2.31091 8.16299C2.31219 6.98183 3.26938 6.02464 4.45054 6.02335H4.85668C5.36397 4.7222 6.83 4.07865 8.13115 4.58595C8.79026 4.84292 9.31158 5.36425 9.56855 6.02335H9.97469C11.1564 6.02271 12.1149 6.98014 12.1155 8.16183C12.1161 9.21077 11.3561 10.1054 10.3209 10.2746C10.0929 10.309 9.86882 10.3662 9.6522 10.4454C9.47145 10.5108 9.28746 10.5669 9.10095 10.6135C8.75394 10.706 8.42599 10.7932 8.24043 10.99C8.02802 11.2153 7.95605 11.6514 8.02608 12.2878C8.31046 14.8694 6.08095 16.2948 5.92534 16.3901C5.83271 16.448 5.72569 16.4787 5.61645 16.4788C5.57724 16.4788 5.53812 16.4748 5.49974 16.4667C5.26732 16.4192 5.08677 16.2358 5.04302 16.0026C5.03447 15.9584 5.03134 15.9134 5.03368 15.8684C5.04983 15.3692 5.02393 14.8695 4.95626 14.3746C4.83722 13.5549 4.59291 12.9927 4.3027 12.871C3.40794 12.4944 2.7466 11.6448 2.61861 10.7072C2.56026 10.2731 2.62561 9.86148 2.79795 9.52264C2.48259 9.13977 2.31039 8.65902 2.31091 8.16299ZM3.94481 9.9136C3.79971 10.028 3.7359 10.2637 3.77403 10.5489C3.86235 11.1057 4.23313 11.5769 4.7536 11.7938C5.46474 12.0925 5.92068 12.904 6.11013 14.2057C6.13114 14.3504 6.14903 14.4932 6.1607 14.6309C6.16848 14.622 6.17587 14.6126 6.18326 14.6037C6.72245 13.9373 6.95197 13.2012 6.86522 12.4154C6.60691 10.0704 7.97939 9.7043 8.79945 9.48567C8.95895 9.44288 9.11067 9.40281 9.23555 9.35496C9.52574 9.24689 9.8262 9.16868 10.1323 9.12154C10.6617 9.03079 11.0173 8.52805 10.9265 7.99864C10.8469 7.53424 10.4459 7.19369 9.97469 7.19042H9.12817C8.84469 7.19052 8.60214 6.98687 8.55319 6.70764C8.42161 5.96726 7.71474 5.47373 6.97435 5.60531C6.4121 5.70523 5.97195 6.14539 5.87202 6.70764C5.82307 6.98687 5.58053 7.19052 5.29704 7.19042H4.45052C3.91339 7.19008 3.47768 7.62524 3.47735 8.16238C3.47715 8.4875 3.63942 8.79121 3.90978 8.97177C4.17737 9.15137 4.2487 9.5139 4.06911 9.78149C4.03514 9.83209 3.99345 9.87706 3.94557 9.91477L3.94481 9.9136Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default DesignatedSmokingIcon;
